export class CalendarUtils {

    /** 日付の取りうる最小値 */
    private static readonly DATE_MIN = new Date(1700, 0, 1);

    /** 日付の取りうる最大値 */
    private static readonly DATE_MAX = new Date(4000, 11, 31);

    /**
     * yyyy年MM月dd日形式の文字列に変換します。
     * @param str yyyy-MM-dd形式の日付文字列
     * @return string yyyy年MM月dd日形式の文字列
     */
    public static formatDateHyphenToJpn(str: string): string {
        if (str) {
            const elem = str.split("-");
            if (elem.length === 3) {
                return `${parseInt(elem[0])}年${parseInt(elem[1])}月${parseInt(elem[2])}日`;
            }
        }
        return "";
    }

    /**
     * yyyy-MM-dd形式の文字列に変換します。
     * @param year 西暦の年
     * @param month 月
     * @param day 日
     * @return string yyyy-MM-dd形式の文字列
     */
    public static formatToHyphen(year: string, month: string, day: string): string {
        if (year && month && day) {
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        }
        return "";
    }

    /**
     * yyyy年MM月dd日形式の文字列に変換します。
     * @param year 西暦の年
     * @param month 月
     * @param day 日
     * @return string yyyy年MM月dd日形式の文字列
     */
    public static formatToJpn(year: string, month: string, day: string): string {
        if (year && month && day) {
            return `${parseInt(year)}年${parseInt(month)}月${parseInt(day)}日`;
        }
        return "";
    }

    /**
     * yyyy/MM/dd形式の文字列に変換します。
     * @param year 西暦の年
     * @param month 月
     * @param day 日
     * @return string yyyy/MM/dd形式の文字列
     */
    public static formatToSlash(year: string, month: string, day: string): string {
        if (year && month && day) {
            return `${year}/${month.padStart(2, "0")}/${day.padStart(2, "0")}`;
        }
        return "";
    }

    /**
     * yyyy-MM-dd形式の日付文字列から、日付要素を分解します
     * @param str yyyy-MM-dd形式の日付文字列
     * @return any 日付要素の連想配列
     */
    public static decomposeDate(str: string): any {
        if (str) {
            const elem = str.split("-");
            if (elem.length === 3) {
                return {year: elem[0], month: elem[1], day: elem[2],};
            }
        }
        return {};
    }

    /**
     * 引数の日付情報が日付として整合しているかチェックします。
     * @param year 西暦の年
     * @param month 月
     * @param day 日
     * @return boolean 日付として整合している場合はtrue、それ以外の場合はfalse
     */
    public static checkDate(year: string, month: string, day: string): boolean {
        // 未入力の場合は正常（true）とする
        if (!year && !month && !day) {
            return true;
        }
        // 日付を生成
        let m = Number(month) - 1;
        let date = new Date(Number(year), m, Number(day));

        // 日付に変換できない場合はfalseを返す
        if (Number.isNaN(date.getTime())) {
            return false;
        }
        // 月に変更がない場合、trueを返す（32日とか、月が繰り上がる日が入力されていないことのチェック）
        return date.getMonth() === m;
    }

    /**
     * 日付が範囲内かどうかチェックします。
     * @param year 西暦の年
     * @param month 月
     * @param day 日
     * @param fromDate 範囲開始
     * @param toDate 範囲終了
     * @return boolean 範囲内の場合はtrue、それ以外の場合はfalse
     */
    public static checkDateRange(year: string, month: string, day: string, fromDate: Date = this.DATE_MIN, toDate: Date = this.DATE_MAX) {
        // 未入力の場合は正常（true）とする
        if (!year && !month && !day) {
            return true;
        }
        if (year.length <= 2) {
            //2桁以下の年の場合、1900+年で計算される仕様なため正常に判定が出来なくなるのでfalseを返す
            return false;
        }
        if (!this.checkDate(year, month, day)) {
            // そもそも日付型式じゃない
            return false;
        }
        // 日付を生成
        let m = Number(month) - 1;
        let dateTime = new Date(Number(year), m, Number(day)).getTime();
        return fromDate.getTime() <= dateTime && dateTime <= toDate.getTime();
    }
}